import fetch from 'isomorphic-fetch';
import {Base64} from 'js-base64';
import {commonErrorHandler, commonHeaders} from './fetch.util';

export const PC_BANG_USER_LOGIN_REQUEST = 'PC_BANG_USER_LOGIN_REQUEST';
export const PC_BANG_USER_LOGIN_FAIL_RESPONSE = 'PC_BANG_USER_LOGIN_FAIL_RESPONSE';

export const CURRENT_USER_DETAIL_REQUEST = 'CURRENT_USER_DETAIL_REQUEST';
export const CURRENT_USER_DETAIL_RESPONSE = 'CURRENT_USER_DETAIL_RESPONSE';

export const PC_BANG_USER_LOGOUT = 'PC_BANG_USER_LOGOUT';

export const PC_BANG_USER_JOIN_REQUEST = 'PC_BANG_USER_JOIN_REQUEST';
export const PC_BANG_USER_JOIN_RESPONSE = 'PC_BANG_USER_JOIN_RESPONSE';

const LOGIN_ERRORS = {
  INCORRECT_LOGIN_INPUTS: 'INCORRECT_LOGIN_INPUTS',
  GOOGLE_RECAPTCHA_VALIDATION_FAILED: 'GOOGLE_RECAPTCHA_VALIDATION_FAILED',
  UNUSABLE_ACCOUNT: 'UNUSABLE_ACCOUNT',
};

export function pcBangUserLoginRequest() {
  return {
    type: PC_BANG_USER_LOGIN_REQUEST,
  };
}

export function pcBangUserLoginFailResponse() {
  return {
    type: PC_BANG_USER_LOGIN_FAIL_RESPONSE,
  };
}

export function currentUserDetailRequest() {
  return {
    type: CURRENT_USER_DETAIL_REQUEST,
  };
}

export function currentUserDetailResponse(currentUserDetail) {
  return {
    type: CURRENT_USER_DETAIL_RESPONSE,
    currentUserDetail,
  };
}

export function pcBangUserLogout() {
  return {
    type: PC_BANG_USER_LOGOUT,
  };
}

export function pcBangUserJoinRequest(formData) {
  return {
    type: PC_BANG_USER_JOIN_REQUEST,
    formData,
  };
}

export function pcBangUserJoinResponse(result) {
  return {
    type: PC_BANG_USER_JOIN_RESPONSE,
    result,
  };
}

export function fetchLoginRequest(userName, password, recaptchaToken, recaptcha, loginFormRef) {
  return dispatch => {
    dispatch(pcBangUserLoginRequest());

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('userName', userName);
    urlSearchParams.append('password', password);
    urlSearchParams.append('g-recaptcha-response', recaptchaToken);

    fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: urlSearchParams,
    })
      .then(response => Promise.all([response, response.status === 200 ? '' : response.json()]))
      .then(([response, json]) => {
        if (response.status === 200) {
          let token = response.headers.get('Authentication');
          sessionStorage.setItem('token', token);
          dispatch(fetchCurrentUserDetailRequest());
        } else if (response.status === 401) {
          if (json.message.startsWith('InvalidRecaptchaParamException')) {
            throw LOGIN_ERRORS.GOOGLE_RECAPTCHA_VALIDATION_FAILED;
          } else if (json.message.startsWith('UnusableAccountException')) {
            throw LOGIN_ERRORS.UNUSABLE_ACCOUNT;
          }
          throw LOGIN_ERRORS.INCORRECT_LOGIN_INPUTS;
        }
      })
      .catch(err => {
        dispatch(pcBangUserLoginFailResponse());

        switch (err) {
          case LOGIN_ERRORS.INCORRECT_LOGIN_INPUTS: {
            alert('잘못된 아이디 또는 패스워드 입니다.');
            recaptcha.reset();
            loginFormRef.password.focus();
            return;
          }
          case LOGIN_ERRORS.GOOGLE_RECAPTCHA_VALIDATION_FAILED: {
            alert('reCAPTCHA 검증에 실패했습니다. 다시 시도해주세요.');
            recaptcha.reset();
            return;
          }
          case LOGIN_ERRORS.UNUSABLE_ACCOUNT: {
            alert('로그인이 불가능한 상태의 아이디입니다.\n고객센터로 문의해주세요.');
            return;
          }
          default: {
            alert('로그인에 실패했습니다.');
          }
        }

        location.reload();
      });
  };
}

export function fetchCurrentUserDetailRequest() {
  return dispatch => {
    dispatch(currentUserDetailRequest());

    fetch(`${API_URL}/users/current-user`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(json => {
        dispatch(currentUserDetailResponse(json));
      })
      .catch(() => {
        sessionStorage.removeItem('token');
        alert('인증에 실패하였습니다.\n다시 로그인 해주세요.');
        window.location.href = '/';
      });
  };
}

export function fetchPcBangUserJoinRequest(formData, recaptchaResponse, history, recaptchaInstance) {
  return dispatch => {
    dispatch(pcBangUserJoinRequest(formData));

    fetch(`${API_URL}/users?g-recaptcha-response=${recaptchaResponse}`, {
      method: 'POST',
      body: formData,
    })
      .then(response => commonErrorHandler(response))
      .then(() => {
        dispatch(pcBangUserJoinResponse('success'));
        window.location.href = '/member-service/join/completion';
      })
      .catch(errObj => {
        dispatch(pcBangUserJoinResponse('fail'));
        errObj.response.json().then(json => {
          let reason = '';

          if (json.message.includes('Bad parameter: ')) {
            let errorField = json.message.substring(15);
            switch (errorField) {
              case 'username':
                reason = '아이디가 올바르지 않습니다.';
                break;
              case 'password':
                reason = '비밀번호가 올바르지 않습니다.';
                break;
              case 'telephone':
                reason = '전화번호가 올바르지 않습니다.';
                break;
              case 'mobile':
                reason = '휴대폰번호가 올바르지 않습니다.';
                break;
              case 'pcBangName':
                reason = 'PC방 상호명이 올바르지 않습니다.';
                break;
              case 'ownerName':
                reason = '대표자 성명이 올바르지 않습니다.';
                break;
              case 'email':
                reason = '이메일이 올바르지 않습니다.';
                break;
              case 'businessLicenseNumber':
                reason = '사업자 등록번호가 올바르지 않습니다.';
                break;
              case 'address':
                reason = '주소가 올바르지 않습니다.';
                break;
              default:
                reason = `${errorField}가 올바르지 않습니다.`;
                break;
            }
          } else {
            reason = '(알 수 없는 오류)';
          }

          alert(`회원가입 요청에 실패했습니다.\n${reason}`);
          recaptchaInstance.reset();
        });
      });
  };
}

export function patchAuthenticationConfig(useIdentityVerificationOnIpManagement) {
  return dispatch => {
    fetch(`${API_URL}/users/current-user/use-identity-verification-on-ip-management`, {
      method: 'PUT',
      headers: commonHeaders(),
      body: JSON.stringify(useIdentityVerificationOnIpManagement),
    })
      .then(response => commonErrorHandler(response))
      .then(response => {
        if (response.status === 204) {
          dispatch(fetchCurrentUserDetailRequest());
          alert('보안 설정 저장에 성공했습니다.');
        } else {
          throw new Error('Unexpected response code from the server: ' + response.status);
        }
      });
  };
}

export function putUserStateToWithdrawn(
  ownerName,
  businessLicenseNumber,
  userName,
  password,
  recaptchaResponse,
  recaptchaInstance,
  history
) {
  let headers = commonHeaders();
  headers.ownerName = Base64.encode(ownerName);
  if (businessLicenseNumber) {
    headers.businessLicenseNumber = Base64.encode(businessLicenseNumber);
  }
  headers.userName = Base64.encode(userName);
  headers.password = Base64.encode(password);
  return () =>
    Promise.all([_getRegisteredPcSlotsSize(), _getTotalRemainingTimeOfCurrentProductEntitlements()])
      .then(pcSlotCountAndRemainingTimeCredit => {
        let registeredPcSlotCount = pcSlotCountAndRemainingTimeCredit[0];
        let remainingTimeCredit = pcSlotCountAndRemainingTimeCredit[1];
        if (registeredPcSlotCount > 0) {
          alert('등록된 IP를 모두 삭제 후 탈퇴 가능합니다. \nIP 관리 페이지로 이동합니다.');
          history.push('/my-pc-bang/management/ip-management');
          return;
        }
        if (remainingTimeCredit > 0) {
          alert('상품 잔여시간이 있는 경우 탈퇴할 수 없습니다. \n보유 상품 현황 페이지로 이동합니다.');
          history.push('/my-pc-bang/usage-status/payment-and-billing');
          return;
        }

        fetch(`${API_URL}/users/current-user/status?g-recaptcha-response=${recaptchaResponse}`, {
          method: 'PUT',
          headers: headers,
          body: JSON.stringify('WITHDRAWN'),
        })
          .then(commonErrorHandler)
          .then(() => {
            alert('탈퇴 처리가 성공하였습니다.');
            sessionStorage.removeItem('token');
            location.href = '/my-pc-bang/management/withdrawal/completion';
          })
          .catch(() => {
            alert('탈퇴 요청이 실패했습니다.\n사용자 정보가 일치하지 않습니다.');
            recaptchaInstance.reset();
          });
      })
      .catch(() => recaptchaInstance.reset());
}

function _getTotalRemainingTimeOfCurrentProductEntitlements() {
  return fetch(`${API_URL}/product-entitlements/current-user`, {
    method: 'GET',
    headers: commonHeaders(),
  })
    .then(commonErrorHandler)
    .then(response => response.json())
    .then(productEntitlements => _sumEntitlementRemainingTime(productEntitlements))
    .catch(() => {
      alert('상품 잔여 시간 확인 중 오류가 발생했습니다.');
      throw '상품 잔여 시간 확인 중 오류';
    });
}

function _getRegisteredPcSlotsSize() {
  return fetch(`${API_URL}/pc-slots/my-pc-slots`, {
    headers: commonHeaders(),
  })
    .then(commonErrorHandler)
    .then(response => response.json())
    .then(pcSlots => pcSlots.length)
    .catch(() => {
      alert('등록된 IP 확인 중 오류가 발생했습니다.');
      throw '등록된 IP 확인 중 오류';
    });
}

function _sumEntitlementRemainingTime(entitlements) {
  return entitlements.reduce((accumulator, entitlement) => accumulator + parseInt(entitlement.remainingTimeCredit), 0);
}

export function patchUserInfo(urlSearchParams, recaptchaResponse, history, recaptchaInstance) {
  return dispatch => {
    let headers = commonHeaders();
    headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    fetch(`${API_URL}/users/current-user?g-recaptcha-response=${recaptchaResponse}`, {
      method: 'PATCH',
      headers,
      body: urlSearchParams,
    })
      .then(response => commonErrorHandler(response))
      .then(() => {
        alert('회원 정보가 수정되었습니다.');
        dispatch(fetchCurrentUserDetailRequest());
        history.push('/');
      })
      .catch(e => e.response.json())
      .then(errorResponse => {
        if (errorResponse && errorResponse.status === 400 && errorResponse.message.includes('Bad parameter: ')) {
          let errorField = errorResponse.message.substring(15);
          if (errorField == 'password') {
            alert(
              '비밀번호 규칙에 맞춰서 작성해야 합니다. 하단의 주의사항을 참고해주세요. (주의: 현재 비밀번호와 다른 비밀번호를 입력해야합니다.)'
            );
          }
        }
        recaptchaInstance.reset();
        throw new Error('회원정보 수정 실패');
      });
  };
}

export function patchUserAutoPayment(autoPayment) {
  return dispatch => {
    let headers = commonHeaders();
    fetch(`${API_URL}/users/current-user/auto-payment`, {
      method: 'PATCH',
      headers,
      body: JSON.stringify(autoPayment),
    })
      .then(response => commonErrorHandler(response))
      .then(() => {
        alert('자동결제 정보/상태가 변경됐습니다.');
        dispatch(fetchCurrentUserDetailRequest());
      })
      .catch(() => {
        throw new Error('자동결제 정보 수정 실패');
      });
  };
}

export function deleteUserAutoPayment() {
  return dispatch => {
    let headers = commonHeaders();
    fetch(`${API_URL}/users/current-user/auto-payment`, {
      method: 'DELETE',
      headers,
    })
      .then(response => commonErrorHandler(response))
      .then(() => {
        alert('자동결제가 해지되었습니다.');
        dispatch(fetchCurrentUserDetailRequest());
      })
      .catch(() => {
        throw new Error('자동결제 해지 실패');
      });
  };
}

export function putUserPassword(password, newPassword, recaptchaResponse, recaptchaInstance, history) {
  return () => {
    let headers = commonHeaders();
    headers.password = Base64.encode(password);

    fetch(`${API_URL}/users/current-user/password?g-recaptcha-response=${recaptchaResponse}`, {
      method: 'PUT',
      headers,
      body: newPassword,
    })
      .then(commonErrorHandler)
      .then(() => {
        alert('비밀번호 변경이 완료되었습니다.\n변경된 비밀번호로 다시 로그인해주세요.');
        sessionStorage.removeItem('token');
        history.replace('/');
      })
      .catch(err => {
        switch (err.response.status) {
          case 400:
            alert(
              '새 비밀번호가 규칙에 맞지 않습니다.\n비밀번호는 8-16자의 영문 대문자, 소문자, 숫자를 혼합하여 생성해야 합니다.'
            );
            break;
          case 403:
            alert('현재 비밀번호가 로그인한 계정 정보와 일치하지 않습니다.');
            break;
          default:
            alert(`서버 호출에 실패하였습니다. 관리자에게 문의하세요.\ncode: [${err.response.status}]`);
            break;
        }
        recaptchaInstance.reset();
      });
  };
}
